var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Card TableCountsCard"},_vm._l((_vm.values),function(value,label){return _c('div',{key:label},[_c('div',[_vm._v(_vm._s(label))]),_c('Counter',{attrs:{"value":value}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }